module.exports = {
  modal: {
    alert: '提醒',
    confirm: '确认'
  }
}



// WEBPACK FOOTER //
// ./~/rctui/lang/zh-cn/modal.js